import { render, staticRenderFns } from "./GuardianSectionView.vue?vue&type=template&id=1bb61146&scoped=true&"
import script from "./GuardianSectionView.vue?vue&type=script&lang=js&"
export * from "./GuardianSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb61146",
  null
  
)

export default component.exports